<template>
<v-container fill-height fluid>

  <v-card class="mx-auto">
    <v-tabs >
      <v-tab>Unprocessed</v-tab>
      <v-tab>Approved</v-tab>
      <v-tab>Enroll</v-tab>
      <v-tab>Enrolled</v-tab>
      <v-tab>Rejected</v-tab>
      <v-tab-item>
        <RegistrationList 
          :status="REGISTRATION_STATUS.UNPROCESSED"
          :reportMode="reportMode">
        </RegistrationList>
      </v-tab-item>
      <v-tab-item>
        <RegistrationList 
          :status="REGISTRATION_STATUS.APPROVED"
          :reportMode="reportMode">
        </RegistrationList>
      </v-tab-item>
      <v-tab-item>
        <RegistrationList 
          :status="REGISTRATION_STATUS.APPROVED"
          :enrollMode="true"
          :reportMode="reportMode">
        </RegistrationList>
      </v-tab-item>
      <v-tab-item>
        <RegistrationList 
          :status="REGISTRATION_STATUS.ENROLLED"
          :reportMode="reportMode">
        </RegistrationList>
      </v-tab-item>
      <v-tab-item>
        <RegistrationList 
          :status="REGISTRATION_STATUS.REJECTED"
          :reportMode="reportMode">
        </RegistrationList>
      </v-tab-item>
    </v-tabs>
  </v-card>
</v-container>
</template>

<script>
import { REGISTRATION_STATUS } from '../../services/constants'
import RegistrationList from '../registrations/RegistrationList'

export default {
		name: 'Registrations',
    components: { RegistrationList },
    props: [ 'reportMode' ],
    data() {
      return {
        REGISTRATION_STATUS
      }
    },
}
</script>